import { planTypes } from '@/common/constants';

export const unlimitedAudioRelatePlansGetter = sourceData => {
  const UnlimitedPlanRelateType = [planTypes.ZOOM_MEETING, planTypes.ZOOM_ROOMS];
  return sourceData.filter(item => UnlimitedPlanRelateType.includes(item.type));
}

export const unlimitedAudioLicenseGetter = (sourceData) => {
  return unlimitedAudioRelatePlansGetter(sourceData).reduce((pre, item) => pre + item.cartInfo.selected_number, 0)
}
